module.exports = __webpack_public_path__ + "static/media/galery-1.e48ecc51.png";